import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import {
  getBrandList,
  getFuelTypeList,
  getModelList,
  getVariantList,
} from 'src/services/buyPolicyMotorService'
import { useDispatch, useSelector } from 'react-redux'
import LoadingModal from 'src/components/common/LoadingModal'
import { showNotificationMessage, updateVehicleDetailsMotor } from 'src/actions'
import { AutoCompleteInput } from 'src/components/BuyPolicy/common/AutoCompleteInput'
import VehicleDetailsCard from 'src/components/BuyPolicy/common/VehicleDetailsCard'
import CustomDatePicker from 'src/components/BuyPolicy/common/CustomDatePicker'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import {
  ERROR_ON_FETCHING_BRAND_LIST,
  ERROR_ON_FETCHING_FEULTYPE_LIST,
  ERROR_ON_FETCHING_MODEL_LIST,
  ERROR_ON_FETCHING_VARIANT_LIST,
  PLEASE_FILL_DETAILS,
  VEHICLE_VARIANT,
} from 'src/utils/constants/BuyPolicy'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const CarDetails = (props) => {
  const { setIsActiveSection } = props
  const classes = useStyles()
  const dispatch = useDispatch()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const token = motorDetails?.token
  const vehicleDetails = motorDetails?.vehicleDetails
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [brandList, setBrandList] = useState([])
  const [fuelTypeList, setFuelTypeList] = useState([])
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [loading, setLoading] = useState(false)
  const [modelList, setModelList] = useState([])
  const [variantList, setVariantList] = useState([])
  const [registerVehicleDetails, setRegisterVehicleDetails] = useState({
    brand: vehicleDetails?.brand?.genericName || '',
    model: vehicleDetails?.model?.modelGenericName || '',
    variant: null,
    fuelType: vehicleDetails?.fuelType?.genericName || '',
    regDate: '',
  })

  const handleNext = () => {
    setSelectedIndex((prevIndex) => (prevIndex + 1) % 5)
  }

  const handlePrevious = () => {
    setSelectedIndex((prevIndex) => (prevIndex === 0 ? 5 - 1 : prevIndex - 1))
  }

  const handleSubmit = () => {
    if (
      !registerVehicleDetails?.brand ||
      !registerVehicleDetails?.model ||
      !registerVehicleDetails?.variant ||
      !registerVehicleDetails?.regDate ||
      !registerVehicleDetails?.fuelType
    ) {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: PLEASE_FILL_DETAILS,
        })
      )
    } else {
      dispatch(
        updateVehicleDetailsMotor({
          ...vehicleDetails,
          brand: { genericName: registerVehicleDetails?.brand },
          model: { modelGenericName: registerVehicleDetails?.model },
          variant: registerVehicleDetails?.variant,
          fuelType: { genericName: registerVehicleDetails?.fuelType },
          regDate: registerVehicleDetails?.regDate,
          vehicleSubmit: true,
        })
      )

      setIsSubmitted(true)
      setIsActiveSection(false)
    }
  }

  const fetchVariantList = async (token, modelId) => {
    setLoading(true)

    const response = await getVariantList(token, modelId)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data

      if (responseData) {
        setVariantList(responseData)
        dispatch(
          updateVehicleDetailsMotor({
            ...vehicleDetails,
            variantList: responseData,
          })
        )
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_ON_FETCHING_VARIANT_LIST,
        })
      )
    }
  }

  const fetchModelList = async (token, brandId) => {
    setLoading(true)

    const response = await getModelList(token, brandId)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData) {
        setModelList(responseData?.vehicleModels)
        dispatch(
          updateVehicleDetailsMotor({
            ...vehicleDetails,
            modelList: responseData?.vehicleModels,
            vehicleLogo: responseData?.vehicleMakeLogo,
          })
        )
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_ON_FETCHING_MODEL_LIST,
        })
      )
    }
  }

  const fetchBrandList = async (token) => {
    setLoading(true)

    const response = await getBrandList(token)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData) {
        setBrandList(responseData)
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_ON_FETCHING_BRAND_LIST,
        })
      )
    }
  }
  const fetchFuelTypeList = async (token) => {
    setLoading(true)

    const response = await getFuelTypeList(token)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData) {
        setFuelTypeList(responseData)
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_ON_FETCHING_FEULTYPE_LIST,
        })
      )
    }
  }

  const handlePrefillData = () => {
    setModelList(vehicleDetails?.modelList || [])
    setVariantList(vehicleDetails?.variantList || [])
    setRegisterVehicleDetails(vehicleDetails)
    setIsSubmitted(vehicleDetails?.vehicleSubmit)
    setIsActiveSection(!vehicleDetails?.vehicleSubmit)
  }

  const handleRegisterVehicleChange = (event, value, detailType) => {
    const updateVehicleDetails = { ...registerVehicleDetails }
    if (detailType) {
      switch (detailType) {
        case VEHICLE_VARIANT?.BRAND:
          updateVehicleDetails[detailType] = value
          fetchModelList(token, value?.id)
          if (value) {
            handleNext()
          }
          break
        case VEHICLE_VARIANT?.MODEL:
          updateVehicleDetails[detailType] = value
          fetchVariantList(token, value?.id)
          if (value) {
            handleNext()
          }
          break
        case VEHICLE_VARIANT?.VARIANT:
        case VEHICLE_VARIANT?.FUELTYPE:
          updateVehicleDetails[detailType] = value
          if (value) {
            handleNext()
          }
          break
        default:
          break
      }
    }
    updateVehicleDetails[event?.target?.name] = event?.target?.value
    setRegisterVehicleDetails(updateVehicleDetails)
  }
  const handleBrandLabel = (option) => option || ''
  const handleModelLabel = (option) => option || ''
  const handleVariantLabel = (option) => option || ''
  const handleFuelLabel = (option) => option?.genericName || ''

  const switchSelectComponent = () => {
    switch (selectedIndex) {
      case 0:
        return (
          <>
            <AutoCompleteInput
              optionList={brandList ? brandList : []}
              handleChange={handleRegisterVehicleChange}
              value={
                registerVehicleDetails?.brand ||
                vehicleDetails.brand?.genericName
              }
              handleOptionLabel={handleBrandLabel}
              label='Brand'
              nameLabel='brand'
            />
          </>
        )
      case 1:
        return (
          <>
            <AutoCompleteInput
              optionList={modelList ? modelList : []}
              handleChange={handleRegisterVehicleChange}
              value={
                registerVehicleDetails?.model ||
                vehicleDetails?.model?.modelGenericName
              }
              handleOptionLabel={handleModelLabel}
              label='Model'
              nameLabel='model'
            />
          </>
        )
      case 2:
        return (
          <>
            <AutoCompleteInput
              optionList={variantList ? variantList : []}
              handleChange={handleRegisterVehicleChange}
              handleOptionLabel={handleVariantLabel}
              value={
                registerVehicleDetails?.variant ||
                vehicleDetails?.variant?.genericVariantName
              }
              label='Variant'
              nameLabel='variant'
            />
          </>
        )
      case 3:
        return (
          <>
            <AutoCompleteInput
              optionList={fuelTypeList ? fuelTypeList : []}
              handleChange={handleRegisterVehicleChange}
              handleOptionLabel={handleFuelLabel}
              value={registerVehicleDetails?.fuelType}
              label='Fuel Type'
              nameLabel='fuelType'
            />
          </>
        )

      case 4:
        return (
          <>
            <Box className={classes.regDateLabel}>Registration Date</Box>
            <CustomDatePicker
              id='date'
              name='regDate'
              placeholder='Reg. Date *'
              value={
                registerVehicleDetails?.regDate || vehicleDetails?.regDate || ''
              }
              onChange={(event) => handleRegisterVehicleChange(event)}
              className={`${classes.dateWidth} ${classes.datePicker}`}
            />
          </>
        )
      default:
        return null
    }
  }

  useEffect(() => {
    handlePrefillData()
    fetchBrandList(token)
    fetchFuelTypeList(token)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleDetails, registerVehicleDetails])

  return (
    <Box>
      <LoadingModal loading={loading} id='loadingModal' />
      <VehicleDetailsCard
        isSubmitted={isSubmitted}
        registerVehicleDetails={registerVehicleDetails}
        switchSelectComponent={switchSelectComponent}
        handleSubmit={handleSubmit}
        handlePrevious={handlePrevious}
        handleNext={handleNext}
        selectedIndex={selectedIndex}
        setIsSubmitted={setIsSubmitted}
        setIsActiveSection={setIsActiveSection}
        vehicleButtonName={'Kutti'}
      />
    </Box>
  )
}

export default CarDetails

const useStyles = makeStyles({
  inputWidth: {
    width: 140,
    fontSize: '12px !important',
  },
  regDateLabel: {
    fontSize: '11px !important',
    marginTop: '-15px',
    paddingBottom: '2px',
    color: '#818181',
  },
  dateWidth: {
    width: 160,
  },
  datePicker: {
    '&  .MuiOutlinedInput-input': {
      height: '0.3rem',
      fontSize: '11px',
    },
  },
})
